module.exports = __webpack_public_path__ + "static/media/advantage01.06eef666.png";